import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Tab } from '@material-ui/core';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { USER_OPERATIONS } from 'helper';
import { RootState } from 'interfaces';
import { ByRealEstate, ByPartners, ByPartnersUgo } from './views';

export const path = '/partners/rating/report';

type Tabs = 'by-real-estate' | 'by-partner';

const PagePartnersRatingReport: React.FC = () => {
  const operations = useSelector((state: RootState) => state.operations);
  const [tab, setTab] = useState<Tabs>('by-real-estate');

  const handleChange = (event: React.SyntheticEvent, newValue: Tabs) => {
    setTab(newValue);
  };

  return (
    <TabContext value={tab}>
      <Box sx={{ p: 3 }}>
        <TabList onChange={handleChange}>
          {[
            <Tab label="По дому" value="by-real-estate" key="by-real-estate" />,
            <Tab label="По партнерам" value="by-partner" key="by-partner" />,

            operations.includes(USER_OPERATIONS.PARTNER_RATING_UGO_VIEW) && (
              <Tab label="По партнерам УГО" value="by-partner-ugo" key="by-partner-ugo" />
            ),
          ].filter(Boolean)}
        </TabList>

        <TabPanel value="by-real-estate">
          <ByRealEstate />
        </TabPanel>

        <TabPanel value="by-partner">
          <ByPartners />
        </TabPanel>

        {operations.includes(USER_OPERATIONS.PARTNER_RATING_UGO_VIEW) && (
          <TabPanel value="by-partner-ugo">
            <ByPartnersUgo />
          </TabPanel>
        )}
      </Box>
    </TabContext>
  );
};

export default PagePartnersRatingReport;
